import { NgModule } from '@angular/core';

import { ApCookieService } from './cookie.service';

@NgModule({
    providers: [ApCookieService]
})
export class ApPersistenceModule {}
